import script from "./ProfileNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileNotifications.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__